/*
  Belléa — Barra sticky de compra en PDP móvil.
  - Aparece cuando el botón de compra principal sale del viewport.
  - Al aparecer: mide su altura → --bellea-sticky-h y desplaza/encoge el
    botón flotante de WhatsApp por encima (nunca lo tapa).
  - Su botón delega el clic al botón real del formulario (variante + carrito de Dawn).
  - Mantiene el precio en sincronía con el bloque de compra.
  Solo actúa en móvil; en desktop la barra permanece oculta por CSS.
*/
(function () {
  'use strict';

  var mobile = window.matchMedia('(max-width: 749px)');
  var bar = document.querySelector('.bellea-pdp-sticky');
  if (!bar) return;

  var submitId = bar.getAttribute('data-target-submit');
  var priceId = bar.getAttribute('data-price-source');
  var realSubmit = submitId ? document.getElementById(submitId) : null;
  var stickyCta = bar.querySelector('[data-bellea-sticky-add]');
  var stickyPrice = bar.querySelector('[data-bellea-sticky-price]');
  var whatsapp = document.querySelector('.bellea-whatsapp');

  /* Delegar el clic al botón real de "Agregar / Comprar / Reservar" */
  if (stickyCta && realSubmit) {
    stickyCta.addEventListener('click', function () {
      if (realSubmit.getAttribute('aria-disabled') === 'true' || realSubmit.disabled) return;
      realSubmit.click();
    });
  }

  /* Sincronizar el precio con el bloque de compra */
  var priceSource = priceId ? document.getElementById(priceId) : null;
  if (priceSource && stickyPrice) {
    var syncPrice = function () {
      var priceEl = priceSource.querySelector('.price-item--sale, .price-item--regular, .price-item');
      var text = (priceEl ? priceEl.textContent : priceSource.textContent).trim();
      if (text) stickyPrice.textContent = text;
    };
    syncPrice();
    new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true, characterData: true });
  }

  /* Mostrar/ocultar la barra según la visibilidad del botón principal */
  function setActive(active) {
    if (active && mobile.matches) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
      document.documentElement.style.setProperty('--bellea-sticky-h', bar.offsetHeight + 'px');
      if (whatsapp) whatsapp.classList.add('bellea-whatsapp--pdp-offset');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      document.documentElement.style.setProperty('--bellea-sticky-h', '0px');
      if (whatsapp) whatsapp.classList.remove('bellea-whatsapp--pdp-offset');
    }
  }

  if (realSubmit && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        // La barra se muestra cuando el botón principal NO está visible.
        setActive(!entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -20% 0px', threshold: 0 }
    );
    observer.observe(realSubmit);
  }

  /* Si se pasa a desktop, desactivar y limpiar el offset */
  mobile.addEventListener('change', function (e) {
    if (!e.matches) setActive(false);
  });
})();
